<template>
    <v-ons-page>
        <ons-toolbar class="main-toolbar">
            <div class="left">
                <v-ons-toolbar-button v-on:click="sidebarToggle">
                    <i class="fal fa-bars"></i>
                </v-ons-toolbar-button>
            </div>
            <div class="center brand-toobar">
                <div class="outlet-navbar">
                    <span class="outlet-store-name">{{ client ? client.client_name : '' }}</span>
                </div>
            </div>
            <div class="right"></div>
        </ons-toolbar>

        <div class="content">

            <v-ons-progress-bar v-if="show_loading" indeterminate></v-ons-progress-bar>

            <div class="content-inner">
                <v-ons-list class="outlets-list" v-if="outlets" data-test-id="cnt-outlets">
                    <v-ons-list-item class="regular-text" v-if="outlets.length == 0">
                        No outlets found for {{ client.client_name }}
                    </v-ons-list-item>
                    <v-ons-search-input
                            v-show="outlets.length > 0"
                            placeholder="Search for a store, cuisine or tag"
                            v-model="outlet_query"></v-ons-search-input>
                    <v-ons-list-item v-if="false && outlets != null && outlets.length > 0" class="regular-text">
                        <template v-if="outlets.length == filtered_outlets.length">
                            Showing {{ outlets.length }} {{ filters.pluralise(outlets.length, 'store') }}
                        </template>
                        <template v-else>
                            Showing {{ filtered_outlets.length }} of {{ outlets.length }} {{ filters.pluralise(outlets.length, 'store') }}
                        </template>
                    </v-ons-list-item>
                    <outlet-list-item v-for="outlet in filtered_outlets"
                                      v-bind:outlet="outlet"
                                      v-bind:show_distance="false"
                                      v-bind:key="outlet.outlet_id"/>
                </v-ons-list>

            </div>
         </div>
         
    </v-ons-page>
</template>

<script>
    import { mapGetters, mapMutations } from 'vuex'

    import { default as OutletListItem } from '../fragments/outlet_list_item'

    export default {

        components: {
            'outlet-list-item': OutletListItem,
        },

        created() {

        },

        mounted() {
            this.loading = true
            this.app.http.get('outlets', { client_subdomain: this.$route.params.subdomain })
                .then(response => {
                    this.loading = false

                    if (response.data.client == null) {
                        this.$ons.notification.alert(
                            'Stores not found - please check the URL.',
                            { title: 'Unable to load stores' }
                        )
                        this.$router.replace(this.app.homeRoute())
                        return
                    }

                    this.outlets = response.data.outlets
                    this.client = response.data.client
                    this.setEmbedClient(this.client.subdomain)
                })
                .catch(error => {
                    this.loading = false
                    this.$ons.notification.alert(
                        this.app.getResponseErrorMessage(error),
                        { title: 'Unable to load stores' }
                    )
                })
        },

        data () {
            return {
                app: this.$root.$data.app,
                outlets: null,
                loading: false,
                client: null,
                outlet_query: '',
            }
        },

        methods: {

            ...mapMutations([
                'setSidebarOpen',
                'setEmbedClient',
            ]),

            sidebarToggle(){
                this.setSidebarOpen(true)
            },

        },

        computed: {

            ...mapGetters([
                'ready',
                'order',
                'basketInfo',
                'outlet',
                'user',
                'location',
            ]),

            filtered_outlets: function(){

                const query = this.outlet_query.toLowerCase().trim()

                if (query.length == 0)
                    return this.outlets

                return this.outlets.filter(outlet => {
                    return outlet.store_display_name.toLowerCase().includes(query) ||
                        outlet.tags.find(t => t.toLowerCase().includes(query))
                })
            },

            show_loading: function(){
                return this.loading
            },
        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/js/components/outlets/client_outlets.vue